export default __webpack_public_path__ + "static/media/headshot.020359e5.jpg";